import {Fragment, observer, React} from '@api'
import {useStores} from '@modules'
import {PrimaryIconButton} from 'centric-ui-components'

export const AssortmentTopToolbarButtons = observer(function () {
  const {catalog: {assortments, settings: {assortment}}} = useStores()
  if (!assortments?.selectedAssortment) return null

  return null // not useful right now

  return (<Fragment>
    <PrimaryIconButton
      tooltip='Show Placeholders'
      tooltipPosition='bottom'
      icon='layers'
      active={!assortment.hero.hideEmptyRows}
      onClick={() => assortment.hero.hideEmptyRows = !assortment.hero.hideEmptyRows}
    />
  </Fragment>)
})


// WEBPACK FOOTER //
// ./src/modules/catalog/internal/gridList/components/groupBy/GroupByCatalog/Assortments/AssortmentCard/AssortmentTopToolbarButtons.tsx